export default "__VITE_ASSET__D$pvYimT__"